import { useSelector } from 'react-redux';
import { languages } from '../redux/reducer/authentication-slice';

const LanguageDrodownValue = () => {
  const languageData = useSelector(languages)
  return languageData
};

export default LanguageDrodownValue;